export default __webpack_public_path__ + "fonts/CancerfondenSans-Regular.5c58333fabe115b7f4b25942ae27b187.woff";